import React, { Fragment, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import TextInput from '../Components/TextInput';
import DropDown from '../Components/DropDown';
import { domains } from '../configs/domains';
import Button from '../Components/Button';
import ProductService from '../Services/ProductService';
import StringUtils from '../Utils/StringUtils';
import { NotificationManager } from 'react-notifications';
import Header from '../Components/Heading';
import SuccessAlert from '../Components/SuccessAlert';
import ClickCopyLabel from '../Components/ClickCopyLabel';

export default function CreateAffiliateProduct() {
	const [ enable, setEnable ] = useState(true);
	const [ res, setRes ] = useState(null);

	const validationSchema = getValidationSchema();
	useEffect(
		() => {
			if (res && res.success) {
				NotificationManager.success('Product Added!');
				formik.setValues({ ...initialValues });
				formik.resetForm({ ...initialValues });
			} else if (res && !res.success) {
				NotificationManager.error(res.message);
			}
		},
		[ res ]
	);
	const formik = useFormik({
		initialValues,
		validationSchema,
		onSubmit: (values, { resetForm, setValues }) => {
			console.log(values);
			setEnable(false);
			ProductService.addProduct(values)
				.then((r) => {
					setEnable(true);

					setRes({ success: r.success, message: r.message, amazon_key: values.amazon_key });
				})
				.catch((e) => {
					setEnable(true);
					setRes({ success: false });
				});
		}
	});

	return (
		<div className="grid justify-items-center">
			<div className="w-4/5">
				<Header text="Create Product" type="h2" />
				{res &&
				res.success && (
					<SuccessAlert>
						<div className="flex items-center">
							<ClickCopyLabel
								text={StringUtils.wrapSnippetId(`AffiliateProductSnippet#${res.amazon_key}`)}
								label="Snippet Id"
							/>
						</div>
					</SuccessAlert>
				)}
				<form>
					<DropDown
						onChange={(data) => {
							formik.setFieldValue('domain', data.value);
						}}
						value={formik.values.domain}
						name="domain"
						options={domains}
						label="Select domain"
						error={formik.errors.domain}
						disabled={!enable}
					/>
					<TextInput
						label="Slug"
						placeholder="Slug"
						name="slug"
						onChange={(e) => {
							formik.setFieldValue('slug', StringUtils.urlFriendlyString(e.target.value));
						}}
						value={formik.values.slug}
						disabled={!enable}
						error={formik.errors.slug}
					/>
					<TextInput
						label="Amazon Key"
						placeholder="Amazon Key"
						name="amazon_key"
						onChange={(e) => {
							formik.setFieldValue('amazon_key', e.target.value.trim());
						}}
						value={formik.values.amazon_key}
						disabled={!enable}
						error={formik.errors.amazon_key}
					/>
					<Button text="Submit" disabled={!enable} type="submit" onClick={formik.handleSubmit} />
				</form>
			</div>
		</div>
	);
}
const initialValues = {
	domain: null,
	slug: null,
	amazon_key: null
};

function getValidationSchema() {
	return Yup.object().shape({
		domain: Yup.string().required('Required'),
		slug: Yup.string()
			.min(3, 'Too Short! It should be more than 3')
			.max(61, 'Too Long! It should be less than 160')
			.matches(/^[a-z0-9_.-]+$/, 'Lower case characters, numbers and dashes only. So white spaces!')
			.required('Required'),
		amazon_key: Yup.string().required('required')
	});
}
